import { Financing } from './Financing';
import { STOCK_LEVELS } from './Stock';

class BaseProduct {
  static buildStockLevel(stockLevel) {
    if (Object.values(STOCK_LEVELS).includes(stockLevel)) {
      return stockLevel;
    }
    return null;
  }

  constructor(params) {
    this.ableToSell = params.ableToSell;
    this.brand = params.brand;
    this.code = params.code;
    this.coverImage = params.coverImage;
    this.financing = params.financing ? new Financing(params.financing) : null;
    this.id = params.id;
    this.isService = params.isService;
    this.name = params.name;
    this.stockLevel = BaseProduct.buildStockLevel(params.stockLevel);
    this.label = params.label;
    this.labelColor = params.labelColor;
    this.notAbleToSellString = params.notAbleToSellString;
    this.maxAmountToSell = params.maxAmountToSell;
    this.inUse = params.inUse;
    this.inWeb = params.inWeb;
    this.specificId = params.specificId;
    this.condition = params.condition;
    this.isWarranty = params.name.includes('Garantía');
    this.addedService = params.serviceProduct && !params.serviceProduct.name.includes('Garantía') ? 0 : 1;
    this.textsService = params.serviceProduct ? params.textsService : [];
  }

  stockIsAvailable() {
    return this.stockLevel === STOCK_LEVELS.available;
  }

  stockIsAlmostNone() {
    return this.stockLevel === STOCK_LEVELS.almostNone;
  }

  stockIsNearlyEmpty() {
    return this.stockLevel === STOCK_LEVELS.low;
  }

  stockIsEmpty() {
    return this.stockLevel === STOCK_LEVELS.none;
  }

  shouldShowPrice() {
    return this.financing && this.financing.priceString;
  }
}

export { BaseProduct };



// WEBPACK FOOTER //
// ./src/models/BaseProduct.js